'use client';

import { useEffect, Suspense } from 'react';

import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import TrustSection from './components/TrustSection';
import BookingSection from './components/BookingSection';
import WhyChooseSection from './components/WhyChooseSection';
import Footer from '@/components/common/Footer';
import LiveChatWidget from '@/components/common/LiveChatWidget';
import Navbar from '@/components/common/Navbar';

export default function Homepage() {
  useEffect(() => {
    // Update page title dynamically for client component
    document.title = 'Gelle Cleaning LLC - Professional Cleaning Services in Twin Cities, MN';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription?.setAttribute('content', 'Book professional cleaning services in Twin Cities, MN. Residential, commercial, deep cleaning, and move-in/out services. Eco-friendly, trusted, and reliable.');
    }
    
    const reveals = document.querySelectorAll('.reveal');
    if (!reveals?.length) return;
    
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    );
    reveals?.forEach(el => observer?.observe(el));
    
    return () => observer?.disconnect();
  }, []);

  return (
    <main className="min-h-screen bg-background relative overflow-hidden">
      {/* Animated Background Layers */}
      <div className="fixed inset-0 -z-10">
        {/* Base Gradient - Full Green */}
        <div className="absolute inset-0 bg-gradient-to-br from-green-600 via-green-500 to-green-700" />
        
        {/* Radial Gradients */}
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gradient-radial from-green-400/50 to-transparent blur-3xl animate-pulse-slow" />
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-gradient-radial from-green-800/40 to-transparent blur-3xl animate-pulse-slower" />
        
        {/* Geometric Pattern Overlay */}
        <div className="absolute inset-0 opacity-30">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgb(255,255,255,0.08)_1px,transparent_1px)] bg-[size:40px_40px]" />
        </div>
        
        {/* Floating Orbs */}
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-green-400/30 rounded-full blur-3xl animate-float" />
        <div className="absolute top-2/3 right-1/3 w-96 h-96 bg-green-300/25 rounded-full blur-3xl animate-float-delayed" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-green-700/20 rounded-full blur-3xl animate-float-slow" />
        
        {/* Sparkle Effect */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.8)_0%,transparent_2px)] bg-[size:100px_100px] animate-sparkle opacity-40" />
      </div>

      <Navbar />
      <HeroSection />
      <ServicesSection />
      <TrustSection />
      <Suspense fallback={<div className="py-24" />}>
        <BookingSection />
      </Suspense>
      <WhyChooseSection />
      <Footer />
      <LiveChatWidget />
    </main>
  );
}